// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import styled from "styled-components";

// Define the styled components
export const ParentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  min-width: 1250px;
  margin: ${MARGIN.fix150} ${MARGIN.fix32};
  align-items: center;
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    min-width: 0px;
  }
`;

export const Title = styled.div`
  margin-left: ${MARGIN.max40};
  margin-bottom: ${MARGIN.max24};
  display: flex;
  width: 100%;
  max-width: 1464px;
  min-width: 1264px;
  justify-content: flex-start;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    min-width: 0px;
  }
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;
  min-width: 1264px;
  max-width: 1464px;
  min-height: 228px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Orange};
  padding: ${MARGIN.max40};
  gap: ${MARGIN.fix16};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    min-width: 0px;
    flex-direction: column;
    width: 342px;
    height: 500px;
    padding: ${MARGIN.max80} ${MARGIN.max24} ${MARGIN.max60} ${MARGIN.max24};
  }
`;

export const IllustrationWrapper = styled.img`
  position: absolute;
  right: 0px;
  bottom: 177px;
`;

export const IllustrationMobileWrapper = styled.img`
  width: 342px;
  position: absolute;
  z-index: 1;
  left: 0px;
  top: -180px;
`;

export const FirstParagraph = styled.div`
  min-width: 588px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    min-width: 0px;
  }
`;

export const SecondParagraph = styled.div`
  min-width: 588px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    min-width: 0px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 499px;
  min-width: 172px;
  margin-right: ${MARGIN.max100};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    justify-content: flex-start;
  }
`;

export const ButtonWrapper = styled.div`
  width: 200px;
  height: 42px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max12};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    min-width: 0px;
  }
`;
